/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Product_CategoryInputs */

const en_reference_dataset_product_category = /** @type {(inputs: Reference_Dataset_Product_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product categories`)
};

/**
* | output |
* | --- |
* | "Product categories" |
*
* @param {Reference_Dataset_Product_CategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_product_category = /** @type {((inputs?: Reference_Dataset_Product_CategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Product_CategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_product_category(inputs)
});